import techupImage from "../assets/tech upskill.png";
import { useState } from "react";
import UserInput from "./user-input-validations";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

const isNotEmpty = (value) => value.trim() !== "" && value.length >= 6;
const isEmailValidated = (value) => value.includes("@") || value.trim() !== "";

const Login = () => {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const {
    value: passwordValue,
    isValid: isNamesValid,
    hasError: hasPasswordError,
    valueChangeHandler: passwordChangeHandler,
    inputBlurHandler: passwordInputBlurHandler,
  } = UserInput(isNotEmpty);

  const {
    value: enteredEmailValue,
    isValid: isEmailValid,
    hasError: hasEmailError,
    valueChangeHandler: emailChangeHandler,
    inputBlurHandler: emailInputBlurHandler,
  } = UserInput(isEmailValidated);

  let formIsValid = false;
  if (isEmailValid && isNamesValid) {
    formIsValid = true;
  }

  const enteringNamesClasses = hasPasswordError
    ? "min-w-full border-[0.3px] p-2 border-[red] mb-2  outline-none"
    : "min-w-full border-[0.3px] p-2 border-zinc-400 outline-none";

  const enteringEmailClasses = hasEmailError
    ? "min-w-full border-[0.3px] p-2 border-[red] outline-none"
    : "min-w-full border-[0.3px] p-2 border-zinc-400 outline-none";

  const submitHandler = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    if (!formIsValid) {
      return;
    }

    try {
      const response = await auth.signInWithEmailAndPassword(
        enteredEmailValue,
        passwordValue
      );
      const data = await response.user;
      if (data?.email) {
        navigate("/dashboard");
        await localStorage.setItem("names", data?.displayName);
        console.log(data?.displayName);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      setError(error.message);
    }
  };
  return (
    <div className="bg-slate-300 h-screen w-screen flex flex-col align-middle justify-center ">
      <div className="my-0 mx-auto w-[500px]">
        <div className="w-full">
          <img className="w-full" src={techupImage} alt={techupImage} />
        </div>
        <div className="w-[500px] bg-white px-8 ">
          <div className="text-center text-3xl font-bold pt-8">Login</div>
          <form
            action=""
            onSubmit={submitHandler}
            className="text-left pb-10 pt-5">
            <div className="control-group">
              {/* adding Email */}
              <div className="pb-4">
                <label htmlFor="Full Name">Email</label>
                <input
                  className={enteringEmailClasses}
                  type="text"
                  value={enteredEmailValue}
                  onChange={emailChangeHandler}
                  onBlur={emailInputBlurHandler}
                />
                {hasEmailError && (
                  <p className="text-[#FFCB33] text-sm">
                    Please Insert valid repository
                  </p>
                )}
              </div>
              <div className="pb-4">
                <label htmlFor="Full Name" className="mb-2">
                  Password
                </label>
                <input
                  className={enteringNamesClasses}
                  type="password"
                  value={passwordValue}
                  onChange={passwordChangeHandler}
                  onBlur={passwordInputBlurHandler}
                />
                {hasPasswordError && (
                  <p className="text-[#FFCB33] text-sm">
                    Please Insert Password
                  </p>
                )}
              </div>

              <div className="w-full  text-right">
                <button
                  disabled={!formIsValid}
                  className="bg-[#FFCB33] text-white px-8 py-2 disabled:bg-black disabled:cursor-not-allowed">
                  {isLoading ? "Loading..." : " Login"}
                </button>
                {/* conso@123 */}
                <div className="text-[red] text-left pt-4">{error}</div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
